import { type ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useRegionalApi } from '~/app/region';
import { useWorkspace } from '~/app/providers';
import { Icon } from '~/components/ui/Icon';

export function labReturnTo(value: string | null): string {
  return value?.startsWith('/mylo-lab/') && !/[\\\r\n]/.test(value)
    ? value
    : '/mylo-lab/';
}
export function MyloLabLaunchPage(): ReactElement {
  const { activeWorkspace } = useWorkspace();
  return (
    <LabLaunch key={activeWorkspace?.id} workspaceId={activeWorkspace?.id} />
  );
}
function LabLaunch({ workspaceId }: { workspaceId?: string }): ReactElement {
  const api = useRegionalApi();
  const { t } = useTranslation('common');
  const [params] = useSearchParams();
  const form = useRef<HTMLFormElement>(null);
  const [ticket, setTicket] = useState('');
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!workspaceId) return () => undefined;
    let disposed = false;
    void api
      .request<{ ticket: string }>(
        `/workspaces/${workspaceId}/mylo-lab/launch`,
        { method: 'POST' }
      )
      .then(result => {
        if (!disposed) setTicket(result.ticket);
      })
      .catch(() => {
        if (!disposed) setError(true);
      });
    return () => {
      disposed = true;
    };
  }, [api, workspaceId, attempt]);
  useEffect(() => {
    if (ticket) form.current?.submit();
  }, [ticket]);
  return (
    <section className="mx-auto flex max-w-lg flex-col gap-4 p-6 text-foreground">
      <Icon name="mylo-lab" className="size-12" />
      <h1 className="text-xl font-semibold text-balance">Mylo lab</h1>
      <p role={error ? 'alert' : 'status'} className="text-sm text-muted">
        {t(error ? 'labLaunchError' : 'labOpening')}
      </p>
      {error && (
        <button
          type="button"
          className="self-start rounded-xl bg-nav-active hover:opacity-85 px-4 py-2 text-nav-active-text focus-visible:outline-2 focus-visible:outline-primary"
          onClick={() => {
            setError(false);
            setTicket('');
            setAttempt(value => value + 1);
          }}
        >
          {t('labRetry')}
        </button>
      )}
      <form ref={form} method="post" action="/mylo-lab/session" hidden>
        <input type="hidden" name="ticket" value={ticket} />
        <input
          type="hidden"
          name="returnTo"
          value={labReturnTo(params.get('returnTo'))}
        />
      </form>
    </section>
  );
}
